export type FooterLink = {
  label: string
  path: string
}

export const footerProductCategoryLinks: FooterLink[] = [
  { label: "Hot Water Generator", path: "/products" },
  { label: "Steam Boiler", path: "/products" },
  { label: "Thermic Fluid Heater", path: "/products" },
  { label: "Water Treatment Monitoring Equipment", path: "/products" },
  { label: "Cooling Water Treatment Chemical", path: "/products" },
  { label: "Boiler Water Treatment Chemical", path: "/products" },
  { label: "Flocculant & Coagulant Chemical", path: "/products" },
  { label: "Fuel Additive Chemical", path: "/products" },
  { label: "Process Chemical", path: "/products" },
  { label: "RO Water Treatment Chemical", path: "/products" },
  { label: "Food Grade / Specialty Chemical", path: "/products" },
  { label: "Industrial Water Treatment Chemical", path: "/products" },
  { label: "Ion Exchange Resin", path: "/products" },
  { label: "Specialty Chemical", path: "/products" },
]

export const footerIndustryLinks: FooterLink[] = [
  { label: "Automobiles", path: "/industries/automobiles" },
  { label: "Cement", path: "/industries/cement" },
  { label: "Chemicals and Fertilisers", path: "/industries/chemicals-fertilisers" },
  { label: "Commercial/ Construction", path: "/industries/commercial-construction" },
  { label: "Dairy", path: "/industries/dairy" },
  { label: "Distillery", path: "/industries/distillery" },
  { label: "Paper & Pulp", path: "/industries/paper-pulp" },
  { label: "Pharmaceuticals", path: "/industries/pharmaceuticals" },
  { label: "Plywood", path: "/industries/plywood" },
  { label: "Power Generation", path: "/industries/power-generation" },
  { label: "Food", path: "/industries/food" },
  { label: "Refineries and Petrochemicals", path: "/industries/refineries-petrochemicals" },
  { label: "Soft Beverages", path: "/industries/soft-beverages" },
  { label: "Metals", path: "/industries/metals" },
  { label: "Sugar", path: "/industries/sugar" },
  { label: "Textiles", path: "/industries/textiles" },
  { label: "Tyre", path: "/industries/tyre" },
]
